<template>
  <div class="wrapper wrapper-content">
    <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="searchCredits">
        <div class="row formcontainer">
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Veículo</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="ABC-1234"
                  class="form-control"
                  v-model="form.licencePlate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="form.onlyNegative" />
                <label class="form-check-label checkboxlabel">Somente PU</label>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Quantidade</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="15"
                  class="form-control"
                  v-model="paginate.pageLimit"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="row">
              <div class="col-sm-6">
                <button class="btn btn-lg btn-primary" type="submit">
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
              <div class="col-sm-6"></div>
                <button
                  class="btn btn-danger m-l-md"
                  @click="deleteAll"
                  v-if="hasPermissionToRemove"
                  :disabled="resultList.length === 0"
                >
                  Remover Todos
                </button>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-sm-6">Motivo</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="Descreva o motivo do estorno da venda"
                  class="form-control"
                  v-model="form.reason"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <th>Pago</th>
          <th>Data</th>
          <th>Hora</th>
          <th>Placa</th>
          <th>Valor</th>
          <th>Nome</th>
          <th></th>
        </thead>
        <tbody>
          <tr class="read" v-for="(item, idx) in resultList" :key="idx">
            <td>{{ item.settled ? 'Pago' : 'Não Pago' }}</td>
            <td>{{ item.createdAt | fillDate }}</td>
            <td>{{ item.createdAt | fillTime }}</td>
            <td>{{ item.vehicle.licencePlate }}</td>
            <td>{{ item.amountPaid }}</td>
            <td>{{ item.user.fullName }}</td>

            <td>
              <button
                class="btn btn-warning"
                @click="createReversalWallet(item)"
              >
                Estornar
              </button>
              <button
                class="btn btn-danger m-l-md"
                @click="deleteCredit(item)"
                v-if="hasPermissionToRemove"
              >
                Remover
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group paginatecontent">
        <button
          class="btn btn-light btn-sm paginatebutton"
          :disabled="paginateHasPageLeft"
          @click="previousPage"
        >
          <i class="fa fa-arrow-left" />
        </button>
        <button
          class="btn btn-light btn-sm paginatebutton"
          :disabled="paginateHasPageRight"
          @click="nextPage"
        >
          <i class="fa fa-arrow-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      form: {
        licencePlate: '',
        reason: '',
        onlyNegative: false,
      },
      resultList: [],
      showSpinner: false,
      paginate: {
        hasPageLeft: false,
        hasPageRight: false,
        countRegister: 0,
        pageSkip: 0,
        pageLimit: 15,
      },
    };
  },
  computed: {
    hasPermissionToRemove() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'wallet-reversal-remove',
        'SHOW',
      );
    },
    paginateHasPageLeft() {
      return !(this.paginate.pageSkip - Number(this.paginate.pageLimit) >= 0);
    },
    paginateHasPageRight() {
      return !(
        this.paginate.pageSkip + Number(this.paginate.pageLimit) <
        this.paginate.countRegister
      );
    },
  },
  filters: {
    fillDate(value) {
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      return new Date(value).toLocaleTimeString('pt-BR');
    },
  },

  methods: {
    async searchCredits() {
      const currentPage = this.paginate.pageSkip;
      const pageBefore = currentPage - Number(this.paginate.pageLimit);
      if (pageBefore <= 0) {
        this.paginate.pageSkip = 0;
      } else {
        this.paginate.pageSkip = pageBefore;
      }
      this.requestList();
    },
    async requestList() {
      if (Number(this.paginate.pageLimit) > 70) {
        this.paginate.pageLimit = 70;
      }
      try {
        const reversalList = await this.$store.dispatch(
          'PAYMENT/GetReversalWalletList',
          {
            licencePlate: this.form.licencePlate,
            onlyNegative: this.form.onlyNegative,
            pageSkip: this.paginate.pageSkip,
            pageLimit: Number(this.paginate.pageLimit),
          },
        );
        this.resultList = reversalList.list;
        this.paginate.countRegister = reversalList.count;
      } catch (error) {
        this.$toasted.error('Não foi possível Listar');
      }
    },
    async createReversalWallet(item) {
      if (this.form.reason.length === 0) {
        return this.$toasted.error('Preencha o motivo.');
      }
      this.showSpinner = true;
      try {
        await this.$store.dispatch('PAYMENT/CreateReversalWallet', {
          creditId: item._id,
          reversalInfo: {
            status: 2,
            reason: this.form.reason,
          },
          consumerToken: item.user.userToken,
        });
        this.$toasted.success('Estorno realizado.');
        this.requestList();
      } catch (error) {
        this.$toasted.error('Não foi possível realizar o estorno');
      } finally {
        this.showSpinner = false;
      }
    },
    async deleteAll() {
      if (this.form.reason.length === 0) {
        return this.$toasted.error('Preencha o motivo.');
      }
      this.showSpinner = true;
      try {
        const fetchAll = this.resultList.map(credit => {
          return this.$store.dispatch('PAYMENT/CreateCourtesy', {
            creditId: credit._id,
            reason: this.form.reason,
          });
        });
        await Promise.all(fetchAll);
        this.$toasted.success('Venda apagada.');
      } catch (error) {
        this.$toasted.error('Não foi possível apagar a venda');
      } finally {
        this.searchCredits();
        this.showSpinner = false;
      }
    },
    async deleteCredit(credit) {
      if (this.form.reason.length === 0) {
        return this.$toasted.error('Preencha o motivo.');
      }
      this.showSpinner = true;
      try {
        await this.$store.dispatch('PAYMENT/CreateCourtesy', {
          creditId: credit._id,
          reason: this.form.reason,
        });
        this.$toasted.success('Venda apagada.');
        // this.searchCredits();
      } catch (error) {
        this.$toasted.error('Não foi possível apagar a venda');
      } finally {
        this.showSpinner = false;
      }
    },
    previousPage() {
      this.paginate.pageSkip -= Number(this.paginate.pageLimit);
      this.requestList();
    },
    nextPage() {
      this.paginate.pageSkip += Number(this.paginate.pageLimit);
      this.requestList();
    },
  },
};
</script>
